import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=af66eb0a&scoped=true"
import script from "./plan-detail.vue?vue&type=script&lang=js"
export * from "./plan-detail.vue?vue&type=script&lang=js"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=af66eb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af66eb0a",
  null
  
)

export default component.exports